
            export default {
              maybeLoad() {
                if (this.loading) return
                this.loading = true
                this.pushEventTo(this.el, "load_more", {})
                clearTimeout(this.loadTimer)
                this.loadTimer = setTimeout(() => { this.loading = false }, 2000)
              },
              mounted() {
                this.intersecting = false
                this.loading = false
                this.lastCursor = this.el.dataset.cursor
                this.observer = new IntersectionObserver((entries) => {
                  this.intersecting = entries[0].isIntersecting
                  if (this.intersecting) this.maybeLoad()
                }, {rootMargin: "200px"})
                this.observer.observe(this.el)
              },
              updated() {
                if (this.el.dataset.cursor !== this.lastCursor) {
                  this.lastCursor = this.el.dataset.cursor
                  this.loading = false
                  clearTimeout(this.loadTimer)
                  if (this.intersecting) this.maybeLoad()
                }
              },
              destroyed() {
                clearTimeout(this.loadTimer)
                if (this.observer) this.observer.disconnect()
              }
            }
          